import { defineStore, _ActionsTree, _GettersTree } from "pinia";
import { createFile } from "@/services/FilesService";
import * as LOG from '@/log';
import useAppStore from "./app";
import { generate } from "@vue/compiler-core";
import generateId from "@/helpers/guid";

export class UploadableFile {
  group: string
  file: any;
  name: string;
  id: string;
  url: string;
  percentageUploaded: number;
  uploadStarted: boolean;


  constructor(group, file) {
    this.group = group;
    this.name = file.name;
    this.file = file;
    this.id = `${file.name}-${file.size}-${file.lastModified}-${file.type}`;
    this.url = URL.createObjectURL(file);
    this.percentageUploaded = 0;
    this.uploadStarted = false;
  }
}

interface State {
  uploadableFiles: (UploadableFile)[];
}

interface Getters extends _GettersTree<State> {
  getFileUpload: (state: State) => (fileId: string) => UploadableFile;
}

interface Actions extends _ActionsTree {
  use(): void;
  setUploadProgress(id: string, percentage: number);
  startUpload(group: string, newFiles: []): Promise<void>;
  addUploadableFiles(group: string, files: UploadableFile[]);
}


const useFilesStore = defineStore<"files", State, Getters, Actions>("files", {
  state: () => ({
    files: [],
    uploadableFiles: [],
  }),
  getters: {
    getFileUpload(state) {
      return (fileId: string) => this.uploadableFiles.find(p => p.id == fileId)
    },
  },
  actions: {
    addUploadableFiles(group: string, newUploadableFiles: []) {

      this.uploadableFiles = this.uploadableFiles.concat(newUploadableFiles)
    },
    fileExists(group: string, otherId: string) {
      const exists = this.uploadableFiles.some(p => p.id == otherId && p.group == group);
      console.log(exists);
      return exists;
    },
    async startUpload(group: string, newFiles: []) {


      const newUploadableFiles = [...newFiles]
        .map((file) => new UploadableFile(group, file))
        .filter((file) => !this.fileExists(group, file.id))

      this.addUploadableFiles(group, newUploadableFiles);

      if (useAppStore().isPreview) { return; }

      LOG.debug("Files store: start upload");
      const filesToUpload = newUploadableFiles; //this.uploadableFiles.filter(p => p.group == group) || []

      for (const file of filesToUpload) {
        const newMessageId = generateId();
        const response = await createFile(file, useAppStore().chatWidgetId, useAppStore().cwToken, newMessageId)
        useAppStore().patchMessage(true, response, true);

        LOG.debug("file uploaded");
      }

      setTimeout(() => {
        this.uploadableFiles = [];
      }, 2000);

      return;
    },
    async setUploadProgress(id, percentage) {
      const file = this.uploadableFiles.find(s => s.id === id) as UploadableFile;
      if (!file) { return; }


      file.percentageUploaded = percentage;
      file.uploadStarted = true;

      // remove file upload progress after 2 sec
      if (percentage == 100) {
        setTimeout(() => {
          const index = this.uploadableFiles.findIndex(s => s.id === file.id);
          if (index > -1) {
            this.uploadableFiles.splice(index, 1);
          }
        }, 2000);
      }


    },
    async use() {
      this.loaded = true;
    },
  },
  // persist: {  // do not persist over reloads etc.
  //   enabled: true,
  //   strategies: [{
  //     key: "tick-uploads",
  //     storage: window.sessionStorage,
  //   }]
  // }
});

export default useFilesStore;
